define("ui", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Ui = exports.None = exports.CircleSlot = exports.CircleBox = exports.Image = exports.Text = exports.Box = exports.Properties = exports.Color = exports.DragType = exports.SizeType = exports.Direction = void 0;
    exports.rem = rem;
    var Direction;
    (function (Direction) {
        Direction[Direction["HORIZONTAL"] = 0] = "HORIZONTAL";
        Direction[Direction["VERTICAL"] = 1] = "VERTICAL";
    })(Direction || (exports.Direction = Direction = {}));
    class Data {
        constructor() {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
            this.radius = 0;
        }
    }
    var SizeType;
    (function (SizeType) {
        SizeType[SizeType["FIT"] = -1] = "FIT";
        SizeType[SizeType["GROW"] = -2] = "GROW";
    })(SizeType || (exports.SizeType = SizeType = {}));
    function isSizeNumber(value) {
        return value >= 0;
    }
    function rem(size) {
        return size * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
    class DragObject {
        constructor(parent, target) {
            this.scrollDisabled = false;
            this.index = 0;
            this.x = 0;
            this.y = 0;
            this.parent = parent;
            this.target = target;
        }
    }
    ;
    var DragType;
    (function (DragType) {
        DragType[DragType["NONE"] = 0] = "NONE";
        DragType[DragType["COPY"] = 1] = "COPY";
        DragType[DragType["MOVE"] = 2] = "MOVE";
    })(DragType || (exports.DragType = DragType = {}));
    const WHITE_IMGAGE = new window.Image();
    WHITE_IMGAGE.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
    class Color {
        constructor(red = 0, green = 0, blue = 0, alpha = 255) {
            this.red = 0;
            this.green = 0;
            this.blue = 0;
            this.alpha = 255;
            this.red = red;
            this.green = green;
            this.blue = blue;
            this.alpha = alpha;
        }
        getColorText() {
            return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
        }
    }
    exports.Color = Color;
    class Properties {
        constructor() {
            this.width = 0;
            this.height = 0;
            this.radius = 0;
            this.gap = 0;
            this.padding = 0;
            this.direction = Direction.HORIZONTAL;
            this.text = "";
            this.source = "";
            this.font = "1rem sans-serif";
            this.fontColor = new Color(0, 0, 0);
            this.backgroundColor = new Color(255, 255, 255, 0);
            this.dragType = DragType.NONE;
            this.isDroppable = false;
            this.scrollDisabled = false;
        }
    }
    exports.Properties = Properties;
    class Element {
        constructor(partialProperties, children) {
            this.data = new Data();
            this.children = [];
            this.properties = new Properties();
            Object.assign(this.properties, partialProperties);
            this.children = children;
        }
        isScrollDisabled(parent, x, y) {
            if (x > this.data.x
                && y > this.data.y
                && x < this.data.x + this.data.width
                && y < this.data.y + this.data.height) {
                if (this.properties.scrollDisabled == true) {
                    return true;
                }
                for (const child of this.children) {
                    const isDisabled = child.isScrollDisabled(this, x, y);
                    if (isDisabled == true) {
                        return true;
                    }
                }
            }
            return false;
        }
        getDraggable(parent, x, y) {
            if (x > this.data.x
                && y > this.data.y
                && x < this.data.x + this.data.width
                && y < this.data.y + this.data.height) {
                if (this.properties.dragType != DragType.NONE) {
                    return new DragObject(parent, this);
                }
                for (const child of this.children) {
                    const dragObj = child.getDraggable(this, x, y);
                    if (dragObj !== undefined) {
                        return dragObj;
                    }
                }
            }
            return undefined;
        }
        getDroppable(x, y) {
            if (x > this.data.x
                && y > this.data.y
                && x < this.data.x + this.data.width
                && y < this.data.y + this.data.height) {
                if (this.properties.isDroppable) {
                    return this;
                }
                for (const child of this.children) {
                    const drop = child.getDroppable(x, y);
                    if (drop !== undefined) {
                        return drop;
                    }
                }
            }
            return undefined;
        }
        calcStaticSize(ui) {
            for (const child of this.children) {
                child.calcStaticSize(ui);
            }
            this.data.width = isSizeNumber(this.properties.width) ? this.properties.width : 0;
            this.data.height = isSizeNumber(this.properties.height) ? this.properties.height : 0;
            this.data.radius = isSizeNumber(this.properties.radius) ? this.properties.radius : 0;
        }
        calcFitSize(ui) {
            let largest = 0;
            let sum = 0;
            for (const child of this.children) {
                child.calcFitSize(ui);
                if (this.properties.direction == Direction.HORIZONTAL) {
                    largest = child.data.height > largest ? child.data.height : largest;
                    sum += child.data.width;
                }
                else {
                    largest = child.data.width > largest ? child.data.width : largest;
                    sum += child.data.height;
                }
            }
            sum += this.properties.padding * 2 + this.properties.gap * (this.children.length - 1);
            largest += this.properties.padding * 2;
            if (this.properties.direction == Direction.HORIZONTAL) {
                this.data.width = this.properties.width == SizeType.FIT ? sum : this.data.width;
                this.data.height = this.properties.height == SizeType.FIT ? largest : this.data.height;
            }
            else {
                this.data.height = this.properties.height == SizeType.FIT ? sum : this.data.height;
                this.data.width = this.properties.width == SizeType.FIT ? largest : this.data.width;
            }
        }
        calcGrowSize(ui) {
            let xGrowSize, yGrowSize;
            if (this.properties.direction == Direction.HORIZONTAL) {
                xGrowSize = this.growingSizeAlongAxis();
                yGrowSize = this.growingSizeAcrossAxis();
            }
            else {
                yGrowSize = this.growingSizeAlongAxis();
                xGrowSize = this.growingSizeAcrossAxis();
            }
            for (const child of this.children) {
                if (child.properties.width == SizeType.GROW) {
                    child.data.width = xGrowSize;
                }
                if (child.properties.height == SizeType.GROW) {
                    child.data.height = yGrowSize;
                }
                child.calcGrowSize(ui);
            }
        }
        calcPosition(ui, offsetX = 0, offsetY = 0) {
            this.data.x = offsetX;
            this.data.y = offsetY;
            offsetX += this.properties.padding;
            offsetY += this.properties.padding;
            for (const child of this.children) {
                if (this.properties.direction == Direction.HORIZONTAL) {
                    child.calcPosition(ui, offsetX, offsetY);
                    offsetX += this.properties.gap + child.data.width;
                }
                else {
                    child.calcPosition(ui, offsetX, offsetY);
                    offsetY += this.properties.gap + child.data.height;
                }
            }
        }
        draw(ui) {
            const ctx = ui.ctx;
            // blue outline
            /*ctx.strokeStyle = "blue";
            ctx.beginPath();
            ctx.strokeRect(
                this.data.x,
                this.data.y,
                this.data.width,
                this.data.height
            );
            ctx.fill();*/
            // blue outline end
            for (const child of this.children) {
                child.draw(ui);
            }
        }
        log(steps = 0) {
            let name = this.constructor.name;
            console.log(`${' '.repeat(steps * 2)}- ${name}:\
    Position(${this.data.x}|${this.data.y}); \
    Size(${this.data.width}|${this.data.height})`);
            for (const child of this.children) {
                child.log(steps + 1);
            }
        }
        growingSizeAlongAxis() {
            let size = this.properties.padding * 2 + this.properties.gap * (this.children.length - 1);
            let nGrowing = 0;
            for (const child of this.children) {
                if (this.properties.direction == Direction.HORIZONTAL) {
                    size += child.data.width;
                    nGrowing += child.properties.width == SizeType.GROW ? 1 : 0;
                }
                else {
                    size += child.data.height;
                    nGrowing += child.properties.height == SizeType.GROW ? 1 : 0;
                }
            }
            if (nGrowing == 0) {
                return 0;
            }
            if (this.properties.direction == Direction.HORIZONTAL) {
                return (this.data.width - size) / nGrowing;
            }
            else {
                return (this.data.width - size) / nGrowing;
            }
        }
        growingSizeAcrossAxis() {
            if (this.properties.direction == Direction.HORIZONTAL) {
                return this.data.height - this.properties.padding * 2;
            }
            else {
                return this.data.width - this.properties.padding * 2;
            }
        }
    }
    class Box extends Element {
        draw(ui) {
            const ctx = ui.ctx;
            ctx.fillStyle = this.properties.backgroundColor.getColorText();
            ctx.fillRect(Math.floor(this.data.x), Math.floor(this.data.y), Math.floor(this.data.width), Math.floor(this.data.height));
            super.draw(ui);
        }
    }
    exports.Box = Box;
    class Text extends Element {
        constructor(partialProperties) {
            super(partialProperties, []);
        }
        calcStaticSize(ui) {
            super.calcStaticSize(ui);
            const ctx = ui.ctx;
            ctx.font = this.properties.font;
            let metrics = ctx.measureText(this.properties.text);
            let height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
            this.data.width = metrics.width;
            this.data.height = height;
        }
        draw(ui) {
            const ctx = ui.ctx;
            ctx.fillStyle = this.properties.backgroundColor.getColorText();
            ctx.fillRect(Math.floor(this.data.x), Math.floor(this.data.y), Math.floor(this.data.width), Math.floor(this.data.height));
            ctx.fillStyle = this.properties.fontColor.getColorText();
            ctx.font = this.properties.font;
            ctx.fillText(this.properties.text, Math.floor(this.data.x), Math.floor(this.data.y + this.data.height));
            super.draw(ui);
        }
    }
    exports.Text = Text;
    class Image extends Element {
        constructor(partialProperties) {
            super(partialProperties, []);
        }
        draw(ui) {
            const ctx = ui.ctx;
            ctx.drawImage(ui.getImage(this.properties.source), Math.floor(this.data.x), Math.floor(this.data.y), Math.floor(this.data.width), Math.floor(this.data.height));
            super.draw(ui);
        }
    }
    exports.Image = Image;
    class CircleBox extends Element {
        constructor(partialProperties, center, edge = []) {
            super(partialProperties, [center].concat(edge));
        }
        isScrollDisabled(parent, x, y) {
            if (Math.sqrt((x - (this.data.x + this.data.width / 2)) *
                (x - (this.data.x + this.data.width / 2)) +
                (y - (this.data.y + this.data.height / 2)) *
                    (y - (this.data.y + this.data.height / 2))) <= this.data.radius) {
                if (this.properties.scrollDisabled == true) {
                    return true;
                }
                for (const child of this.children) {
                    const isDisabled = child.isScrollDisabled(this, x, y);
                    if (isDisabled == true) {
                        return true;
                    }
                }
            }
            return false;
        }
        calcGrowSize(ui) {
            super.calcGrowSize(ui);
            if (this.properties.radius == SizeType.GROW) {
                let r = Math.min(this.data.width, this.data.height) / 2;
                r = r < 0 ? 0 : r;
                this.data.radius = r;
            }
        }
        calcPosition(ui, offsetX = 0, offsetY = 0) {
            this.data.x = offsetX;
            this.data.y = offsetY;
            offsetX += this.properties.padding;
            offsetY += this.properties.padding;
            if (this.children.length < 1) {
                return;
            }
            offsetX += this.data.width / 2;
            offsetY += this.data.height / 2;
            this.children[0].calcPosition(ui, offsetX - this.children[0].data.width / 2, offsetY - this.children[0].data.height / 2);
            for (let i = 0; i < this.children.length - 1; i++) {
                const child = this.children[i + 1];
                child.calcPosition(ui, offsetX + Math.cos((2 * Math.PI) / (this.children.length - 1) * i) * this.properties.radius - child.data.width / 2, offsetY + Math.sin((2 * Math.PI) / (this.children.length - 1) * i) * this.properties.radius - child.data.height / 2);
            }
        }
        draw(ui) {
            const ctx = ui.ctx;
            ctx.beginPath();
            ctx.arc(Math.floor(this.data.x + this.data.width / 2), Math.floor(this.data.y + this.data.height / 2), Math.floor(this.data.radius), 0, 2 * Math.PI);
            ctx.fillStyle = this.properties.backgroundColor.getColorText();
            ctx.fill();
            // blue outline
            //ctx.stroke();
            // blue outline end
            super.draw(ui);
        }
    }
    exports.CircleBox = CircleBox;
    class CircleSlot extends Element {
        constructor(partialProperties, item = undefined) {
            super(partialProperties, item ? [item] : []);
        }
        calcPosition(ui, offsetX = 0, offsetY = 0) {
            this.data.x = offsetX;
            this.data.y = offsetY;
            offsetX += this.properties.padding;
            offsetY += this.properties.padding;
            if (this.children.length < 1) {
                return;
            }
            offsetX += this.data.width / 2;
            offsetY += this.data.height / 2;
            this.children[0].calcPosition(ui, offsetX - this.children[0].data.width / 2, offsetY - this.children[0].data.height / 2);
        }
        draw(ui) {
            const ctx = ui.ctx;
            ctx.beginPath();
            ctx.arc(Math.floor(this.data.x + this.data.width / 2), Math.floor(this.data.y + this.data.height / 2), Math.floor(this.data.radius), 0, 2 * Math.PI);
            ctx.fillStyle = this.properties.backgroundColor.getColorText();
            ctx.fill();
            // blue outline
            ctx.stroke();
            // blue outline end
            super.draw(ui);
        }
    }
    exports.CircleSlot = CircleSlot;
    class None extends Element {
        constructor() {
            super({}, []);
        }
        draw(_ui) { }
    }
    exports.None = None;
    class Ui {
        constructor(canvas, ctx) {
            this.imageMap = new Map();
            this.last_interaction_x = 0;
            this.last_interaction_y = 0;
            this.logDisplayed = false;
            this.canvas = canvas;
            this.ctx = ctx;
            this.rootElement = new Box({
                width: canvas.width,
                height: canvas.height
            }, []);
            canvas.addEventListener("mousedown", this.positionFromMouseEvent.bind(this, this.onPressEvent.bind(this)));
            canvas.addEventListener("touchstart", this.positionFromTouchEvent.bind(this, this.onPressEvent.bind(this)));
            canvas.addEventListener("mousemove", this.positionFromMouseEvent.bind(this, this.onMoveEvent.bind(this)), { passive: false });
            canvas.addEventListener("touchmove", this.positionFromTouchEvent.bind(this, this.onMoveEvent.bind(this)), { passive: false });
            canvas.addEventListener("mouseup", this.positionFromMouseEvent.bind(this, this.onReleaseEvent.bind(this)));
            canvas.addEventListener("mouseleave", this.positionFromMouseEvent.bind(this, this.onReleaseEvent.bind(this)));
            canvas.addEventListener("touchend", this.positionFromTouchEvent.bind(this, this.onReleaseEvent.bind(this)));
            canvas.addEventListener("touchcancel", this.positionFromTouchEvent.bind(this, this.onReleaseEvent.bind(this)));
        }
        positionFromMouseEvent(func, event) {
            let boundingRect = this.canvas.getBoundingClientRect();
            func(event.clientX - boundingRect.left, event.clientY - boundingRect.top, event);
        }
        positionFromTouchEvent(func, event) {
            let boundingRect = this.canvas.getBoundingClientRect();
            if (event.touches.length < 1) {
                func(this.last_interaction_x, this.last_interaction_y, event);
            }
            func(event.touches[0].clientX - boundingRect.left, event.touches[0].clientY - boundingRect.top, event);
            this.last_interaction_x = event.touches[0].clientX - boundingRect.left;
            this.last_interaction_y = event.touches[0].clientY - boundingRect.top;
        }
        onPressEvent(x, y) {
            if (this.dragInfo !== undefined) {
                return;
            }
            this.dragInfo = this.rootElement.getDraggable(this.rootElement, x, y);
            if (this.dragInfo === undefined) {
                if (this.rootElement.isScrollDisabled(this.rootElement, x, y)) {
                    const dragObject = new DragObject(this.rootElement, this.rootElement);
                    this.dragInfo = dragObject;
                    dragObject.scrollDisabled = true;
                }
                return;
            }
            this.dragInfo.x = x;
            this.dragInfo.y = y;
            this.dragInfo.index = this.dragInfo.parent.children.indexOf(this.dragInfo.target);
            if (this.dragInfo.index == -1) {
                this.dragInfo = undefined;
                return;
            }
            if (this.dragInfo.target.properties.dragType == DragType.MOVE) {
                this.dragInfo.parent.children.splice(this.dragInfo.index, 1);
            }
            if (this.dragInfo.target.properties.dragType == DragType.COPY) {
                let copyTarget = Object.create(Object.getPrototypeOf(this.dragInfo.target));
                copyTarget.properties = structuredClone(this.dragInfo.target.properties);
                copyTarget.properties.dragType = DragType.MOVE;
                copyTarget.data = structuredClone(this.dragInfo.target.data);
                copyTarget.children = [];
                this.dragInfo.target = copyTarget;
            }
        }
        onMoveEvent(x, y, event) {
            if (this.dragInfo === undefined) {
                return;
            }
            this.dragInfo.x = x;
            this.dragInfo.y = y;
            event.preventDefault();
        }
        onReleaseEvent(x, y) {
            if (this.dragInfo == undefined) {
                return;
            }
            if (this.dragInfo.scrollDisabled) {
                this.dragInfo = undefined;
                return;
            }
            const drop = this.rootElement.getDroppable(x, y);
            if (drop !== undefined && drop.children.length == 0) {
                drop.children.push(this.dragInfo.target);
            }
            this.dragInfo = undefined;
        }
        loadImage(source) {
            const newImage = new window.Image();
            newImage.src = source;
            this.imageMap.set(source, newImage);
        }
        getImage(source) {
            if (this.imageMap.has(source) == false) {
                this.loadImage(source);
            }
            const img = this.imageMap.get(source);
            if (img && img.complete && img.naturalWidth !== 0) {
                return img;
            }
            return WHITE_IMGAGE;
        }
        setLayout(rootElement) {
            this.rootElement.children = [rootElement];
        }
        renderLayout() {
            this.canvas.style.width = "100%";
            const dpr = window.devicePixelRatio || 1;
            const rect = this.canvas.getBoundingClientRect();
            this.canvas.width = rect.width * dpr;
            this.canvas.height = rect.height * dpr;
            this.ctx.scale(dpr, dpr);
            this.canvas.style.width = `${rect.width}px`;
            this.canvas.style.height = `${rect.width}px`;
            this.rootElement.properties.width = this.canvas.width / dpr;
            this.rootElement.properties.height = this.canvas.height / dpr;
            this.rootElement.calcStaticSize(this);
            this.rootElement.calcFitSize(this);
            this.rootElement.calcGrowSize(this);
            this.rootElement.calcPosition(this);
            if (this.logDisplayed == false) {
                this.rootElement.log();
                this.logDisplayed = true;
            }
            this.rootElement.draw(this);
            if (this.dragInfo !== undefined) {
                if (!this.dragInfo.scrollDisabled) {
                    this.dragInfo.target.calcPosition(this, this.dragInfo.x - this.dragInfo.target.data.width / 2, this.dragInfo.y - this.dragInfo.target.data.height / 2);
                    this.dragInfo.target.draw(this);
                }
            }
        }
    }
    exports.Ui = Ui;
});
define("compat", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isShopify = isShopify;
    exports.res = res;
    function isShopify() {
        return !"".includes("%");
    }
    // ids are in liquid asset_url form
    function res(id) {
        if (id.startsWith("{") && id.endsWith("}") && id.includes("'")) {
            return `assets/${id.split("'")[1]}`;
        }
        return id;
    }
});
define("options", ["require", "exports", "compat"], function (require, exports, compat) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getOptions = getOptions;
    function getOptions() {
        return compat.isShopify() ? new ShopifyOptions() : new DebugOptions();
    }
    class DebugOptions {
        constructor() {
            this.beadsSize = 0;
            this.intermediateStones = "";
            this.braceletLength = 0;
            this.letter = "";
            this.letterColor = "";
            this._updateAvailable = true;
        }
        uploadButtonEvent(uploadButton, event) {
            if (!uploadButton.files) {
                return;
            }
            if (uploadButton.files.length < 1) {
                return;
            }
            let formData = new FormData();
            formData.append("file", uploadButton.files[0]);
            fetch("http://localhost:8001/process-image/", {
                method: "POST",
                body: formData
            }).then(response => {
                console.log(response);
            }).catch(error => {
                console.error(error);
            });
        }
        setup() {
            let options = document.getElementsByClassName("option");
            let uploadButton = document.getElementById("eyeForAi");
            if (uploadButton) {
                uploadButton.onchange = this.uploadButtonEvent.bind(this, uploadButton);
            }
            for (let option of options) {
                let value = option.getElementsByClassName("option-value")[0];
                let optionButton = option.getElementsByClassName("option-buttons")[0];
                if (optionButton != undefined) {
                    let buttons = optionButton.getElementsByClassName("option-button");
                    value.textContent = buttons[0].textContent;
                    buttons[0].classList.add("option-button-selected");
                    for (let button of buttons) {
                        button.onclick = () => {
                            this.optionCallback(buttons, button, value);
                            this._updateAvailable = true;
                        };
                    }
                }
                let optionText = option.getElementsByClassName("option-texts")[0];
                if (optionText != undefined) {
                    let inp = optionText.getElementsByClassName("option-text");
                    if (inp.length > 0) {
                        inp[0].oninput = () => {
                            this._updateAvailable = true;
                        };
                    }
                }
            }
            this.hasUpdated();
            this._updateAvailable = true;
        }
        ;
        hasUpdated() {
            if (!this._updateAvailable) {
                return false;
            }
            this.beadsSize = parseInt(this.getConfigValue("beadsSize"));
            this.intermediateStones = this.getConfigValue("intermediateStones");
            this.braceletLength = parseInt(this.getConfigValue("braceletLength"));
            this.letter = this.getConfigValue("letter");
            this.letterColor = this.getConfigValue("letterColor");
            this._updateAvailable = false;
            return true;
        }
        setManualUpdate() {
            this._updateAvailable = true;
        }
        optionCallback(buttons, selectedButtons, value) {
            for (let button of buttons) {
                button.classList.remove("option-button-selected");
            }
            selectedButtons.classList.add("option-button-selected");
            value.textContent = selectedButtons.textContent;
        }
        getConfigValue(targetOptionId) {
            let targetOption = document.getElementById(targetOptionId);
            let values = targetOption.getElementsByClassName("option-value");
            if (values.length > 0) {
                return values[0].textContent;
            }
            let inputValues = targetOption.getElementsByTagName("input");
            if (inputValues.length > 0) {
                return inputValues[0].value;
            }
            console.error("option: " + targetOptionId + " not found");
            return "";
        }
    }
    var ShopifyOptionType;
    (function (ShopifyOptionType) {
        ShopifyOptionType[ShopifyOptionType["VALUE_END_OF_TAG"] = 0] = "VALUE_END_OF_TAG";
        ShopifyOptionType[ShopifyOptionType["STRING_INPUT"] = 1] = "STRING_INPUT";
        ShopifyOptionType[ShopifyOptionType["NUMERIC_INPUT"] = 2] = "NUMERIC_INPUT";
    })(ShopifyOptionType || (ShopifyOptionType = {}));
    class ShopifyOptions {
        constructor() {
            this.beadsSize = 6;
            this.intermediateStones = "Silver";
            this.braceletLength = 17;
            this.letter = "A";
            this.letterColor = "Silver";
            this._updateAvailable = true;
        }
        setup() {
            let rightView = document.querySelector(".halo-productView-right");
            if (!rightView) {
                return;
            }
            let tags = rightView.getElementsByTagName("legend");
            for (let tag of tags) {
                if (!tag.parentElement) {
                    continue;
                }
                let inputElements = tag.parentElement.getElementsByTagName("input");
                for (let inputElement of inputElements) {
                    inputElement.addEventListener("click", () => {
                        this._updateAvailable = true;
                    });
                    inputElement.addEventListener("input", () => {
                        this._updateAvailable = true;
                    });
                }
            }
            this.hasUpdated();
            this._updateAvailable = true;
        }
        hasUpdated() {
            if (!this._updateAvailable) {
                return false;
            }
            this.beadsSize = parseInt(this.getConfigValue("Beads Size:", ShopifyOptionType.VALUE_END_OF_TAG, "6"));
            this.intermediateStones = this.getConfigValue("Intermediate Stones:", ShopifyOptionType.VALUE_END_OF_TAG, "Silver");
            this.braceletLength = parseInt(this.getConfigValue("Length:", ShopifyOptionType.NUMERIC_INPUT, "17"));
            this.letter = this.getConfigValue("Letter:", ShopifyOptionType.STRING_INPUT, "A");
            this.letterColor = this.getConfigValue("Letter Color", ShopifyOptionType.VALUE_END_OF_TAG, "Silver");
            this._updateAvailable = false;
            return true;
        }
        setManualUpdate() {
            this._updateAvailable = true;
        }
        getConfigValue(targetTagText, type, alternative) {
            let rightView = document.querySelector(".halo-productView-right");
            if (!rightView) {
                return alternative;
            }
            let targetTag = undefined;
            let tags = rightView.getElementsByTagName("legend");
            for (let tag of tags) {
                if (tag.innerText.startsWith(targetTagText)) {
                    targetTag = tag;
                    break;
                }
            }
            if (targetTag == undefined || !targetTag.parentElement) {
                return alternative;
            }
            if (type == ShopifyOptionType.VALUE_END_OF_TAG) {
                let textParts = targetTag.innerText.split(" ");
                if (textParts.length < 1) {
                    return alternative;
                }
                return textParts[textParts.length - 1];
            }
            let inputElements = targetTag.parentElement.getElementsByTagName("input");
            if (type == ShopifyOptionType.STRING_INPUT) {
                for (let inputElement of inputElements) {
                    if (inputElement.type != "text") {
                        continue;
                    }
                    if (inputElement.value == "") {
                        return alternative;
                    }
                    return inputElement.value;
                }
            }
            if (type == ShopifyOptionType.NUMERIC_INPUT) {
                for (let inputElement of inputElements) {
                    if (inputElement.type != "number") {
                        continue;
                    }
                    if (Number.isNaN(parseInt(inputElement.value))) {
                        return alternative;
                    }
                    return inputElement.value;
                }
            }
            return alternative;
        }
    }
});
define("bracelet_builder_component", ["require", "exports", "ui", "compat", "options"], function (require, exports, ui, compat, opts) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class BraceletBuilder extends HTMLCanvasElement {
        buildLayout() {
            let length = this.opts.braceletLength;
            length = Number.isInteger(length) ? length : 17;
            length = Math.min(Math.max(length, 13), 20);
            const pearlCount = Math.floor(length / (this.opts.beadsSize / 10));
            let margin = 0;
            let bigR = Math.min(this.clientWidth, this.clientHeight - 6 * ui.rem(1) - this.PEARL_SIZE) / 2;
            let aR = bigR / (1 + Math.sqrt(2 * (1 - Math.cos(2 * Math.PI / (pearlCount + margin)))) / 2);
            let bR = bigR - aR;
            this.PEARL_SIZE = bR * 2 - 0.5 * ui.rem(1);
            this.SLOT_SIZE = bR;
            this.CIRCLE_SIZE = aR;
            if (this.PEARL_SIZE > ui.rem(2)) {
                this.PEARL_SIZE = ui.rem(2);
                this.SLOT_SIZE = this.PEARL_SIZE * (2 / 3);
            }
            if (this.CIRCLE_SIZE > ui.rem(17)) {
                this.CIRCLE_SIZE = ui.rem(17);
            }
            const pearls_6mm = [
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_brown.png?v=110880186196307221311750879390")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_dark_blue.png?v=4640664629920630041750879398")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_dark_brown.png?v=135020943582920607591750879407")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_dark_cyan.png?v=148441968653162424161750879415")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_dark_green.png?v=39773099399859036251750879422")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_light_blue.png?v=133123955018370992671750879430")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_light_green.png?v=76316224560693327261750879445")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/6mm_light_purple.png?v=131864192240264248471750879454")),
            ];
            const pearls_8mm = [
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_brown.png?v=162533650847859167741750879462")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_dark_blue.png?v=14423608252340499731750879470")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_dark_brown.png?v=45377366601298319091750879487")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_dark_cyan.png?v=157847888885264376151750879499")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_dark_green.png?v=106538310109592742351750879507")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_light_blue.png?v=47048557705691209991750879522")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_light_green.png?v=64241390184793546131750879540")),
                this.create_pearl_spawner(compat.res("//auroraspectra4.de/cdn/shop/t/3/assets/8mm_light_purple.png?v=73157951460533137221751395894")),
            ];
            return new ui.Box({
                width: ui.SizeType.GROW,
                height: ui.SizeType.GROW,
                padding: ui.rem(1),
                direction: ui.Direction.VERTICAL,
                backgroundColor: this.BACKGROUND_COLOR
            }, [
                new ui.Box({
                    width: ui.SizeType.GROW,
                    height: ui.SizeType.FIT,
                    padding: ui.rem(1),
                    gap: ui.rem(1),
                    direction: ui.Direction.VERTICAL,
                    backgroundColor: this.BACKGROUND_COLOR
                }, [
                    new ui.Text({
                        text: "Pearls",
                        font: "1.75rem Arial"
                    }),
                    new ui.Box({
                        width: ui.SizeType.GROW,
                        height: ui.SizeType.FIT,
                        padding: ui.rem(1),
                        direction: ui.Direction.HORIZONTAL,
                        gap: ui.rem(1),
                        backgroundColor: new ui.Color(150, 150, 150),
                        scrollDisabled: true,
                    }, this.opts.beadsSize == 6 ? pearls_6mm : pearls_8mm)
                ]),
                new ui.Box({
                    width: ui.SizeType.GROW,
                    height: ui.SizeType.GROW,
                    padding: ui.rem(1),
                    backgroundColor: this.BACKGROUND_COLOR
                }, [
                    new ui.CircleBox({
                        width: ui.SizeType.GROW,
                        height: ui.SizeType.GROW,
                        radius: this.CIRCLE_SIZE,
                        scrollDisabled: true,
                        //radius: ui.SizeType.GROW,
                        backgroundColor: this.CIRCLE_EDGE_COLOR
                    }, new ui.CircleBox({
                        width: ui.SizeType.GROW,
                        height: ui.SizeType.GROW,
                        radius: this.CIRCLE_SIZE - this.SLOT_SIZE - ui.rem(1) / 2,
                        backgroundColor: this.CIRCLE_EDGE_COLOR
                    }, new ui.CircleBox({
                        width: ui.SizeType.GROW,
                        height: ui.SizeType.GROW,
                        radius: this.CIRCLE_SIZE - this.SLOT_SIZE * 2 - ui.rem(1),
                        backgroundColor: this.CIRLCE_INNER_COLOR
                    }, new ui.Text({
                        font: "3.5rem Arial",
                        text: "17cm"
                    })), Array.from({ length: pearlCount }, () => new ui.CircleSlot({
                        width: this.PEARL_SIZE,
                        height: this.PEARL_SIZE,
                        radius: this.SLOT_SIZE,
                        backgroundColor: this.SLOT_COLOR,
                        isDroppable: true
                    }))))
                ])
            ]);
        }
        constructor() {
            super();
            this.SLOT_COLOR = new ui.Color(100, 100, 100);
            this.CIRCLE_EDGE_COLOR = new ui.Color(150, 150, 150);
            this.CIRLCE_INNER_COLOR = new ui.Color(120, 120, 120);
            this.BACKGROUND_COLOR = new ui.Color(230, 230, 230);
            this.PEARL_SIZE = ui.rem(2);
            this.CIRCLE_SIZE = ui.rem(17);
            this.SLOT_SIZE = this.PEARL_SIZE * (2 / 3);
            this.context = this.getContext("2d");
            this.deltaTime = 0;
            this.lastTime = 0;
            this.requestAnimationId = 0;
            this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
            this.opts = opts.getOptions();
            this.opts.setup();
            this.uiui = new ui.Ui(this, this.context);
            this.layout = this.buildLayout();
            this.uiui.setLayout(this.layout);
        }
        handleResize(entries) {
            for (const entry of entries) {
                const { width, height } = entry.contentRect;
                if (this.width !== width || this.height !== height) {
                    this.width = width;
                    this.height = height;
                    this.opts.setManualUpdate();
                    this.draw();
                }
            }
        }
        connectedCallback() {
            this.resizeObserver.observe(this);
            this.requestAnimationId = requestAnimationFrame(newTime => this.loop(newTime));
        }
        disconnectedCallback() {
            this.resizeObserver.unobserve(this);
            cancelAnimationFrame(this.requestAnimationId);
        }
        loop(newTime) {
            this.deltaTime = (newTime - this.lastTime) / 1000.0;
            this.lastTime = newTime;
            this.draw();
            this.requestAnimationId = requestAnimationFrame(newTime => this.loop(newTime));
        }
        draw() {
            this.context.clearRect(0, 0, this.width, this.height);
            if (this.opts.hasUpdated()) {
                this.layout = this.buildLayout();
                this.uiui.setLayout(this.layout);
            }
            this.uiui.renderLayout();
        }
        create_pearl_spawner(res) {
            return new ui.CircleSlot({
                width: this.PEARL_SIZE,
                height: this.PEARL_SIZE,
                radius: this.SLOT_SIZE,
                backgroundColor: this.SLOT_COLOR,
            }, new ui.Image({
                source: res,
                width: this.PEARL_SIZE,
                height: this.PEARL_SIZE,
                dragType: ui.DragType.COPY
            }));
        }
    }
    customElements.define("bracelet-builder", BraceletBuilder, { extends: "canvas" });
});
